// Style sheets
require("./scss/main.scss");

// Custom JavaScript
require("./js/header");
require("./js/carousel");
require("./js/cart");
require("./js/cart-empty-confirm");
require("./js/cart-burst");
require("./js/cart-lock");
require("./js/filter-bar");
require("./js/hero");
require("./js/menu-cart");
require("./js/mobile-menu");
require("./js/product-bar");
require("./js/product-specs-tabs");
require("./js/faq");
require("./js/trial");
require("./js/thankyou-downloads");
require("./js/collapsible-text");
require("./js/back-to-top");
require("./js/currency-switcher");
require("./js/personal-price");
require("./js/discount-toast");
require("./js/discount-teasers");
require("./js/my-deals");
require("./js/licenses");
require("./js/rebuild-roll");
require("./js/completion-info-box");
require("./js/bundle-products");
require("./js/video-pause");
require("./js/consent-embeds");
